export const isRTL = (language: string) => {
  const rtlLanguages = ["ar", "he"];
  return rtlLanguages.includes(language);
};

export const syncDocumentLanguage = (lng: string) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = isRTL(lng) ? "rtl" : "ltr";
};
